export var GameCommand;
(function (GameCommand) {
    GameCommand["Nothing"] = "nothing";
    GameCommand["NewGame"] = "newGame";
    GameCommand["StartGame"] = "startGame";
    GameCommand["TakeTop"] = "takeTop";
    GameCommand["TakeDiscard"] = "takeDiscard";
    GameCommand["Discard"] = "discard";
    GameCommand["Knock"] = "knock";
    GameCommand["Pass"] = "pass";
    GameCommand["Layoff"] = "layoff";
    GameCommand["Undercut"] = "undercut";
    GameCommand["Scoring"] = "scoring";
    GameCommand["EndRound"] = "endRound";
    GameCommand["Next"] = "next";
})(GameCommand || (GameCommand = {}));
export class GameCommandData {
}
export class Action {
    constructor(command, commnadData = {}, tablePosition = -1, note = '') {
        this.command = GameCommand.Nothing;
        this.note = '';
        this.command = command;
        this.commandData = commnadData;
        this.tablePosition = tablePosition;
        this.note = note;
    }
}
export var GameEvent;
(function (GameEvent) {
    GameEvent["StateChanged"] = "stateChanged";
    GameEvent["RoundEnded"] = "roundEnded";
    GameEvent["RoundStageChanged"] = "roundStageChanged";
    GameEvent["GameOver"] = "gameOver";
    GameEvent["CardDiscarded"] = "cardDiscarded";
    GameEvent["TookDiscard"] = "tookDiscard";
    GameEvent["TookTop"] = "tookTop";
    GameEvent["Passed"] = "passed";
    GameEvent["CurrentPlayerChanged"] = "currentPlayerChanged";
    GameEvent["CardMoved"] = "cardMoved";
    GameEvent["InvalidAction"] = "invalidAction";
    GameEvent["PlayerChanged"] = "playerChanged";
})(GameEvent || (GameEvent = {}));
export var RoundStage;
(function (RoundStage) {
    RoundStage["PreGame"] = "preGame";
    RoundStage["Deal"] = "deal";
    RoundStage["FirstCard"] = "firstCard";
    RoundStage["MustTakeTop"] = "mustTakeTop";
    RoundStage["Draw"] = "draw";
    RoundStage["Discard"] = "discard";
    RoundStage["Knock"] = "knock";
    RoundStage["Layoff"] = "layoff";
    RoundStage["Undercut"] = "undercut";
    RoundStage["Scoring"] = "scoring";
    RoundStage["GameOver"] = "gameOver";
})(RoundStage || (RoundStage = {}));
export var CardPile;
(function (CardPile) {
    CardPile["Player1Hand"] = "hand0";
    CardPile["Player2Hand"] = "hand1";
    CardPile["Discard"] = "discard";
    CardPile["Draw"] = "draw";
})(CardPile || (CardPile = {}));
export class Player {
    constructor() {
        this.id = 0;
        this.name = '';
        this.avatar = '';
        this.type = '';
        this.level = '';
        this.tablePosition = 0;
        this.score = 0;
        this.timeLeft = undefined;
    }
}
export var PlayerPosition;
(function (PlayerPosition) {
    PlayerPosition[PlayerPosition["NoOne"] = -1] = "NoOne";
    PlayerPosition[PlayerPosition["Player1"] = 0] = "Player1";
    PlayerPosition[PlayerPosition["Player2"] = 1] = "Player2";
})(PlayerPosition || (PlayerPosition = {}));
export class RoundDetails {
    constructor() {
        this.results = '';
        this.playerToIncrease = -1;
        this.whoKnocked = -1;
        this.isBigGin = false;
        this.isGin = false;
        this.isKnocked = false;
        this.wasUndercut = false;
        this.difference = 0;
        this.player1Name = '';
        this.player2Name = '';
        this.player1Score = 0;
        this.player2Score = 0;
        this.player1Deadwood = 0;
        this.player2Deadwood = 0;
        this.ginPoints = 0;
        this.undercutPoints = 0;
        this.totalPoints = 0;
        this.winner = -1;
    }
}
//# sourceMappingURL=data:application/json;base64,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